import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeading from "@/components/base/SectionHeading";
import { useSeo } from "@/hooks/useSeo";
import { dramaInfo } from "@/mocks/drama";
import StoryTimeline from "./components/StoryTimeline";
import CommentsPanel from "./components/CommentsPanel";

export default function DetailPage() {
  useSeo({
    title: "善良的小姨子-剧情详情",
    description:
      "善良的小姨子剧情详情介绍：全面梳理剧集背景、关键剧情事件与情感脉络，助你快速了解这部家庭情感剧的故事走向。",
    keywords: "善良的小姨子剧情,善良的小姨子剧情介绍,善良的小姨子分集剧情,家庭情感剧",
  });

  return (
    <SiteLayout>
      <section className="w-full px-4 md:px-8 pt-6 md:pt-8">
        <nav className="flex items-center gap-1.5 text-xs text-foreground-500 mb-5">
          <Link to="/" className="hover:text-primary-600 cursor-pointer">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700">剧情详情</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-6 md:gap-10">
          <div className="w-full max-w-[300px] mx-auto lg:mx-0">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden border border-background-200 bg-background-200">
              <img
                src={dramaInfo.cover}
                alt="善良的小姨子 剧集海报"
                title="善良的小姨子 剧情详情 海报"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-600 mb-2">
              <span className="w-4 h-0.5 bg-accent-500"></span>
              剧情介绍
            </span>
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              {dramaInfo.title} · 剧情详情
            </h1>
            <p className="text-accent-600 text-sm md:text-base mt-3 font-medium">{dramaInfo.tagline}</p>

            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mt-4 text-sm text-foreground-600">
              <span>{dramaInfo.year}</span>
              <span>{dramaInfo.region}</span>
              <span>{dramaInfo.genre}</span>
              <span className="text-primary-600 font-medium">共 {dramaInfo.totalEpisodes} 集</span>
              <span className="flex items-center gap-1 text-secondary-700 font-bold">
                <i className="ri-star-fill"></i> {dramaInfo.rating}
              </span>
            </div>

            <h2 className="font-heading text-lg font-bold text-foreground-950 mt-6 mb-2">剧情梗概</h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{dramaInfo.synopsisFull}</p>

            <div className="flex flex-wrap gap-2 mt-5">
              {dramaInfo.tags.map((tag) => (
                <span key={tag} className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                  {tag}
                </span>
              ))}
            </div>

            <div className="flex flex-wrap items-center gap-3 mt-7">
              <Link
                to={`/play/${dramaInfo.updatedEpisodes}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-fill text-lg"></i> 观看最新第{dramaInfo.updatedEpisodes}集
              </Link>
              <Link
                to="/play/1"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm md:text-base font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-restart-line text-lg"></i> 从第1集开始
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="剧情脉络"
          title="关键剧情时间轴"
          desc="点击左侧章节查看对应剧情的具体摘要，快速掌握故事发展节奏。"
        />
        <StoryTimeline />
      </section>

      <section className="w-full px-4 md:px-8 pb-10 md:pb-14">
        <SectionHeading eyebrow="观众评论" title="大家都在说（演示）" />
        <CommentsPanel />
      </section>
    </SiteLayout>
  );
}